import React from "react";
import Paper from "@mui/material/Paper";
import classes from "./ITable.module.scss";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import {Grid} from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import {getRandomInt, isEven} from "../../../tools/helper";
import EmptyList from "../emptyList/EmptyList";


const ITable = ({
                    titleHeaders,
                    rows,
                    notActiveColor = null,
                    multiPath = [],
                    idKey = "id",
                    btn,
                    sx,
                    haveAnimation = false
                }) => {

    // const allKeys = multiPath.map((item) => item.key)


    /* deprecated and not required anymore */
    // const myFunc = (row, key, keyIndex) => {
    //
    //     if (multiPath[keyIndex]?.btn && allKeys.indexOf(key) > -1) {
    //         return <Button onClick={(row) => multiPath[keyIndex]?.onClick}>{row[key]}</Button>
    //
    //
    //     } else if (allKeys.indexOf(key) > -1) {
    //         return (<Link onClick={multiPath[keyIndex].onClick ?? null}
    //                       to={`${multiPath[keyIndex].to}/${row[multiPath[keyIndex]?.id ?? idKey]}`}>{row[key]}</Link>)
    //     } else {
    //         return row[key]
    //     }
    //
    // }

    const makeARow = (row) => {
        let output = [];
        for (const key in row) {
            let active = row?.row_is_active ?? true;
            if (key === "id") continue;
            if (key === "row_is_active") continue;

            // let keyIndex = allKeys.indexOf(key);

            let key_id = getRandomInt(111111, 999999) * getRandomInt(111111, 999999);
            output.push(
                <TableCell key={'cell_' + key_id}
                           style={{
                               color: active ? '#000' : notActiveColor ?? '#797979',
                               border: 5, ...row[key]?.style ?? null
                           }} sx={sx}
                           align="center">
                    <div style={{
                        width: "100%",
                        height: '100%',
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "baseline",
                        ...row[key]?.content_style ?? null
                    }}>
                        {row[key]?.content ?? row[key]}
                    </div>
                </TableCell>)

        }
        return output;
    }


    return (
        <>
            <TableContainer component={Paper} className={classes.table}>
                <Table sx={{minWidth: 300,}} aria-label="simple table">
                    <TableHead>
                        <TableRow style={{boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.04)"}} sx={sx}>
                            {
                                titleHeaders?.map((titleHeader, index) => (
                                    <TableCell key={'header_' + index} sx={sx} align="center"
                                               style={{border: "none"}}>
                                        <div style={{
                                            width: "100%",
                                            height: '100%',
                                            display: "flex",
                                            justifyContent: 'center',
                                            alignItems: "baseline",
                                            ...titleHeader?.style ?? null
                                        }}>
                                            {titleHeader?.content ?? titleHeader}
                                        </div>

                                    </TableCell>
                                ))
                            }


                        </TableRow>
                    </TableHead>
                    <TableBody sx={sx} className={classes.tableBody}>
                        {rows.length === 0 &&
                            <TableRow>
                                <TableCell colSpan={40}>
                                    <Grid sx={{textAlign: "center", position: "relative"}}><EmptyList/></Grid>
                                </TableCell>
                            </TableRow>
                        }

                        {rows?.map((row, index) => {
                            console.log(row, typeof row)
                            return (
                                <TableRow
                                    key={'row_' + row.id}
                                    sx={{
                                        filter: `blur(${haveAnimation ? '0.3' : '0'}px)`,
                                        '&:hover': {
                                            scale: haveAnimation ? '1.02' : '1',
                                            boxShadow: haveAnimation ? '0px 0px 15px -5px rgba(43, 43, 43, 0.61)' : 'none',
                                            zIndex: haveAnimation ? 1 : 0,
                                            filter: haveAnimation ? 'contrast(110%) blur(0px)' : 'none'
                                        },
                                        '&:last-child td, &:last-child th': {border: 0}
                                    }}
                                    className={`${classes.rowTable} ${!isEven(index) ? classes.rowTableOdd : ''}`}
                                >

                                    {makeARow(row)}
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}
export default ITable